import React from "react";
import "./viewModal.css";

const ViewModal = ({ show, data, onClose }: any) => {
  if (!show || !data) return null;

  return (
    <div className={`right-modal-overlay ${show ? "open" : ""}`}>
      <div className="right-modal">
        <div className="right-modal-header">
          <h5 className="m-0">Contact Request Details</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        <div className="right-modal-body">
          <div className="view-row">
            <label>Name</label>
            <div className="value">{data.name || "-"}</div>
          </div>

          <div className="view-row">
            <label>Email</label>
            <div className="value">{data.email || "-"}</div>
          </div>

          <div className="view-row">
            <label>Category</label>
            <div className="value">{data?.category?.name || "-"}</div>
          </div>

          <div className="view-row">
            <label>Message</label>
            <div className="value">{data.message || "-"}</div>
          </div>

          {data.status === "RESOLVED" && (
            <>
              <div className="view-row">
                <label>Action By</label>
                <div className="value">{data?.actionBy?.name || "-"}</div>
              </div>

              <div className="view-row">
                <label>Comment</label>
                <div className="value">{data?.comment || "-"}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
